import {Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";
import {ConfigStateService} from "../../../../../config/config-state.service";

declare var $: any;

@Component({
    selector: "modern-table-view-controls",
    templateUrl: "./modern-table-view-controls.component.html",
    styleUrls: ["./modern-table-view-controls.component.scss"],
    standalone: false
})
export class ModernTableViewControlsComponent implements OnInit {
  @Input() questions;
  @Input() parentTableQuestion;
  @Input() taxReturnId;

  @ViewChild("tableViewControls")
  tableViewControls: ElementRef;

  isColumnVisible = {};

  constructor(private config: ConfigStateService) {
  }

  ngOnInit() {
    const viewPreferences = this.loadViewPreferences();
    if (viewPreferences) {
      this.isColumnVisible = viewPreferences;
      this.toggleQuestionVisiblity();
    }
  }

  toggleDropdown() {
    this.questions.forEach(q => {
      this.isColumnVisible[q.id] = !q.toggleOff;
    });
    const viewPreferences = this.loadViewPreferences();
    if (viewPreferences) {
      this.isColumnVisible = viewPreferences;
      this.toggleQuestionVisiblity();
    }
    $(this.tableViewControls.nativeElement).modal("show");
  }

  hideDropdown() {
    $(this.tableViewControls.nativeElement).modal("hide");
  }

  toggleQuestionVisiblity() {
    this.questions.forEach(q => {
      const isVisible = this.isColumnVisible[q.id];
      q.toggleOff = !isVisible;
    });
  }

  applyViewControls() {
    this.toggleQuestionVisiblity();
    const allVisible = this.questions.every(q => !q.toggleOff);

    if (allVisible) {
      this.clearViewPreferences();
    } else {
      this.storeViewPreferences(this.isColumnVisible);
    }
    this.hideDropdown();
  }

  resetToShowAll() {
    Object.keys(this.isColumnVisible).forEach(k => {
      this.isColumnVisible[k] = true;
    });
  }

  storeViewPreferences(viewPreferences) {
    const key = `table-view-control-${this.taxReturnId}-${this.parentTableQuestion.id}`;
    window.localStorage.setItem(key, JSON.stringify(viewPreferences));
  }

  clearViewPreferences() {
    const key = `table-view-control-${this.taxReturnId}-${this.parentTableQuestion.id}`;
    window.localStorage.removeItem(key);
  }

  loadViewPreferences() {
    const key = `table-view-control-${this.taxReturnId}-${this.parentTableQuestion.id}`;

    let stored = window.localStorage.getItem(key) || null;
    if (!stored) { return null; }

    const viewPreferences = JSON.parse(stored);
    return viewPreferences;
  }

}
